<template>
  <aside
    class="background-pattern-sand-100 absolute place-content-start lg:place-content-center top-0 py-5 left-0 w-full min-h-full grid grid-cols-1 gap-5 align-start justify-items-start justify-start lg:py-0 lg:grid-cols-[1fr_350px] xl:grid-cols-[1fr_600px]"
  >
    <section
      class="grid grid-cols-[20px_1fr] gap-5 order-2 md:place-content-start md:self-center md:gap-y-9"
    >
      <header class="grid items-center col-span-full grid-cols-subgrid">
        <button ref="closeButtonRef" @click="$emit('close')">
          <ChevronIcon
            direction="left"
            class="hover:cursor-pointer grid-start-1"
          />
        </button>
        <h2 class="text-h2 text-mbzuai-dark-navy-500 grid-start-2">
          {{ heading }}
        </h2>
      </header>

      <p
        class="text-body-small text-surface-500 grid-cols-subgrid md:col-start-2 col-span-full"
      >
        <DrupalMarkup :content="copy" />
      </p>

      <div class="grid-cols-subgrid md:col-start-2 col-span-full">
        <ParagraphCallToActionDefault
          button-label="Find out more"
          icon="arrow"
          :button-url="{
            title: '',
            href: '/',
          }"
        />
      </div>
    </section>
    <Responsive
      :image="selectedTopic?.topicImage"
      text-align="left"
      class="max-w-md order-1 lg:order-2 lg:max-w-lg mx-auto"
    />
  </aside>
</template>

<script setup lang="ts">
import type { SelectedTopic } from '~/types';
import Responsive from '../../paragraph/image/Responsive.vue';

const props = defineProps<{
  selectedTopic: SelectedTopic | null;
}>();

defineEmits<{
  close: [];
}>();

const closeButtonRef = ref<HTMLButtonElement | null>(null);

const heading = computed(
  () => props.selectedTopic?.topic?.topicCopy?.sectionHeading ?? ''
);

const copy = computed(
  () => props.selectedTopic?.topic?.topicCopy?.sectionCopy ?? ''
);

watch(
  () => props.selectedTopic,
  (value) => {
    if (!value) return;
    nextTick(() => {
      closeButtonRef.value?.focus();
    });
  }
);

onMounted(() => {
  closeButtonRef.value?.focus();
});
</script>
